import dayjs from "@lib/dayjs"
import { JobStatus } from "@utils/constants"
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const JobCard = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isClosed = data?.status === JobStatus.CLOSED && "Closed";
  const isExpired = data?.status === JobStatus.EXPIRED && "Expired";

  return (
    <NavLink
      to={`/job/${data?.hiringCompany?._id}/${data?._id}/applicant-list`}
      state={data}
      onClick={() => {
        //   dispatch(setJobDetail(data));
        // navigate(`/job/${data?._id}/applicants`, { state: data });
      }}
      className="grid grid-cols-[1.1fr_1.6fr_0.3fr] gap-12 items-center justify-between bg-white border-b border-[#ececec] rounded px-3 py-5 hover:bg-gray-50 cursor-pointer"
    >
      <div className="flex flex-col gap-1">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-light-black font-medium">
            {data?.refNo}
          </span>
          <div className="flex items-center justify-center bg-gray-100 rounded-md py-1.5 px-4 text-xs font-medium text-primary">
            {data?.status === JobStatus.LIVE && "Live"}
            {data?.status === JobStatus.DRAFT && "Draft"}
            {data?.status === JobStatus.UNPUBLISHED && "Unpublished"}
            {data?.status === JobStatus.CLOSED && "Closed"}
            {data?.status === JobStatus.EXPIRED && "Expired"}
          </div>
        </div>
        <span className="text-sm font-bold text-primary">{data?.title}</span>
        <span className="text-xss font-medium text-light-black">Hiring Company:&nbsp;&nbsp;&nbsp;<span className="font-semibold text-primary">{data?.hiringCompany?.companyName || 'N/A'}</span></span>
        <div className="flex items-center justify-between mt-3">
          <div className="flex items-center gap-2">
            <span className="text-xss text-gray-400 font-medium">
              Published:
            </span>
            <span className="text-xss text-primary italic font-medium">
              {data?.publishedDate &&
                dayjs(data?.publishedDate).format("hh:mm a DD MMM YY")}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xss text-gray-400 font-medium">
              {isClosed ? "Closed" : "Expiring"}:
            </span>
            <span className="text-xss text-primary italic font-medium">
              {dayjs(isClosed ? data?.updatedAt : data?.expiredAt).format(
                "hh:mm a DD MMM YY"
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <span className="text-sm font-bold text-primary mb-2">{data?.jobTitle}</span>
        <div className="flex items-center gap-5">
          <span className="text-xs text-light-black font-medium italic">
            {dayjs(data?.latestTrackerDetails?.updatedAt).format("hh:mm a")}
          </span>
          <span className="text-xs text-light-black font-medium italic">
            {dayjs(data?.latestTrackerDetails?.updatedAt).format("DD MMM YYYY")}
          </span>
        </div>
        <div className="flex items-center border border-gray-200 bg-gray-50 rounded-md h-[3.8rem] py-3 px-5">
          <span className="text-xs font-medium text-primary">
            Latest Activity : {data?.latestTrackerDetails?.status || 'N/A'}
          </span>
        </div>
      </div>

      <div className="flex flex-col justify-end items-center text-xs font-medium gap-4 h-full">
        Applicants
        <div className="relative w-16 h-16 flex items-center justify-center">
          {/* Glow layer */}
          {data?.applicantCount ? (
            <span className="absolute inset-0 rounded-full bg-green-500 opacity-5 animate-pulse"></span>
          ) : null}

          {/* Badge */}
          <div
            className={`relative z-10 w-16 h-16 rounded-full border-[3px] ${data?.applicantCount ? "border-green-500" : "border-gray-400"
              } flex items-center justify-center`}
          >
            <span className="text-xs font-semibold text-black">
              {data?.applicantCount}
            </span>
          </div>
        </div>
      </div>
    </NavLink>
  );
};


export default JobCard